class Disciplines {
  constructor(elems) {

    this.elems = elems;

    this.elems.disciplines = {
      $disciplines : [].slice.call(document.getElementsByClassName('disciplines-category'))
    };

    this.elems.disciplines.$disciplines.map(($discipline, i) => {
      $discipline.addEventListener('click', (e) => {
        $('.disciplines-category').removeClass('darkgray');
        e.target.classList.add('darkgray');
        window.history.pushState(null, null, e.target.getAttribute('href'));
      });
    });

  }
}

export default Disciplines;



// WEBPACK FOOTER //
// ./app/javascript/disciplines/index.js